import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { featuredProjects } from '../data/projects';
import { fadeUp } from '../lib/motion';
import ProjectCard from './ProjectCard';
import Magnetic from './Magnetic';
import TextReveal from './TextReveal';
import './FeaturedProjects.css';

const FeaturedProjects = () => {
  const navigate = useNavigate();

  return (
    <section className="section featured" id="work">
      <div className="container">
        <div className="featured__head">
          <div className="section-head" style={{ marginBottom: 0 }}>
            <motion.span
              className="eyebrow"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: '-60px' }}
            >
              Selected work
            </motion.span>
            <TextReveal as="h2" className="section-title" text="Recent & award-winning builds" mode="words" inView />
          </div>
          <Magnetic strength={0.25}>
            <button className="btn btn-ghost featured__all" onClick={() => navigate('/projects')}>
              All projects <ArrowRight size={18} />
            </button>
          </Magnetic>
        </div>

        <div className="featured__grid">
          {featuredProjects.map((p, i) => (
            <ProjectCard key={p.id} project={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
